import { useMemo } from 'react';
import { useLang } from 'hooks/lang';

import { parseTasksToOverview, taskOverviewConfig } from 'entities';

import { Row, Link, Dot, Tag } from 'components/Blocks';
import { TaskIcon } from 'components/Icons';

import { ItemGroup } from '../ItemGroup';
import { useAppWrapper } from '../../WrapperContext';

import { useProject } from 'providers/Project';
import { useTeam } from 'providers/Team';
import { useUser } from 'hooks';

export function TaskBreakdown() {
  const { escapeDrawer } = useAppWrapper();

  const { teamUsers } = useTeam();
  const { projectList } = useProject();

  const user = useUser();

  const { t } = useLang();

  const configs = Object.values(taskOverviewConfig);

  const tasksOverview = useMemo(() => {
    return parseTasksToOverview({
      projects: projectList,
      loggedUser: user,
      teamUsers,
    });
  }, [projectList, user, teamUsers]);

  const hasExpiredTasks = !!tasksOverview.overdue.length;

  const show = !!(user.team.canAssumeProject || user.team.hasServices);

  if (!show) return null;

  return (
    <ItemGroup
      name={t('tasks')}
      icon={<TaskIcon size={22} />}
      items={configs}
      itemKey="id"
      addErrorIndication={hasExpiredTasks}
      minimizedLink={{ to: 'tasksOverview' }}
      render={({ getLabel, tab }) => (
        <Link
          to="tasksOverview"
          params={{ tab }}
          className="flex flex-1 justify-between text-sm font-semibold text-primary-foreground dark:text-accent-foreground"
          onClick={escapeDrawer}
        >
          <Row gap="3">
            <Dot
              size={14}
              color="transparent"
              className="border border-primary-foreground dark:border-accent-foreground"
            />
            <span className="text-xs">{getLabel(t)}</span>
          </Row>

          <Tag
            name={tasksOverview[tab as keyof typeof taskOverviewConfig].length}
            color="primary-foreground"
            className="w-8 text-primary dark:bg-muted dark:text-muted-foreground"
            size="tiny"
          />
        </Link>
      )}
    />
  );
}
